var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircleSolid = function SvgUserCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    fillRule: "evenodd",
    d: "M10 1.042a8.958 8.958 0 1 0 0 17.916 8.958 8.958 0 0 0 0-17.916m-.007 4.166a2.71 2.71 0 0 0-2.711 2.709 2.71 2.71 0 0 0 2.711 2.708 2.71 2.71 0 0 0 2.711-2.708 2.71 2.71 0 0 0-2.711-2.709m4.208 8.525c-2.223-2.4-6.222-2.276-8.398-.003l-.156.156a.625.625 0 0 0 .023.905A6.44 6.44 0 0 0 10 16.458a6.44 6.44 0 0 0 4.33-1.667.625.625 0 0 0 .023-.905z",
    clipRule: "evenodd"
  })));
};
export default SvgUserCircleSolid;